angular.module("avant.filters").filter "ProductApr",
["$filter",
($filter) ->
  (apr, precision, truncateZero) ->
    if truncateZero && parseFloat(apr) == 0
      $filter('number')(parseFloat(apr))
    else
      $filter('number')(parseFloat(apr)*100, precision)

]
